var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPointer = function SvgMapPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.071 4.797A5.6 5.6 0 0 1 10 3.2a5.6 5.6 0 0 1 3.929 1.597 5.38 5.38 0 0 1 1.621 3.84c0 2.1-1.393 4.143-2.929 5.735A20.3 20.3 0 0 1 10 16.646a20.3 20.3 0 0 1-2.621-2.274C5.843 12.78 4.45 10.736 4.45 8.636a5.38 5.38 0 0 1 1.621-3.84m3.545 13.288L10 17.5za.7.7 0 0 0 .766 0L10 17.5c.383.586.383.586.384.585h.002l.004-.004.016-.01a8 8 0 0 0 .268-.185 21.688 21.688 0 0 0 2.955-2.542c1.589-1.647 3.321-4.035 3.321-6.708a6.78 6.78 0 0 0-2.04-4.838A7 7 0 0 0 10 1.8a7 7 0 0 0-4.91 1.998 6.78 6.78 0 0 0-2.04 4.838c0 2.673 1.732 5.06 3.321 6.708a21.7 21.7 0 0 0 3.165 2.688l.058.038.016.011.004.003zM12.5 8.75a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0",
    clipRule: "evenodd"
  })));
};
export default SvgMapPointer;